var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBottomLeftWidget = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 184,
  height: 117,
  viewBox: "0 0 184 117",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-8.9%",
  y: "-3.7%",
  width: "117.8%",
  height: "114.8%",
  filterUnits: "objectBoundingBox",
  id: "a"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0183293269 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#EDF1F5",
  width: 184,
  height: 117,
  rx: 6
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 176.5,
  cy: 54.5,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  opacity: 0.849,
  cx: 176.5,
  cy: 108.5,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  opacity: 0.849,
  cx: 7.5,
  cy: 54.5,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  opacity: 0.849,
  cx: 7.5,
  cy: 108.5,
  r: 4.5
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)",
  transform: "translate(18 50)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  width: 45,
  height: 54,
  rx: 3
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F5F5F5",
  cx: 5.5,
  cy: 13.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F5F5F5",
  cx: 5.5,
  cy: 41.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 41 25)",
  fill: "#F5F5F5"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 0h17a3 3 0 0 1 3 3v1a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V0Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M10 11h17a3 3 0 0 1 3 3v1a3 3 0 0 1-3 3H13a3 3 0 0 1-3-3v-4ZM10 39h17a3 3 0 0 1 3 3v1a3 3 0 0 1-3 3H13a3 3 0 0 1-3-3v-4Z",
  fill: "#F5F5F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 0h39a3 3 0 0 1 3 3v2H0V3a3 3 0 0 1 3-3Z",
  fill: "currentColor"
})))));
export default SvgBottomLeftWidget;